import { createReducer as _createReducer } from '@ngrx/store';
import { isSourcedAction } from './create-sourced-action.function';
export function createReducer(initialState, ...ons) {
    const reducer = _createReducer(initialState, ...ons);
    return function (state = initialState, action) {
        const type = isSourcedAction(action) ? action.typeWithoutSource : action.type;
        const reTypedAction = Object.assign(Object.assign({}, action), { type });
        return reducer(state, reTypedAction);
    };
}
